import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

const WrapperSearch = styled.div`
  box-shadow: 1px 1px 2px 0 ${props => props.theme.colors.gray};
  display: flex;
`;

const InputSearch = styled.input`
  background-color: ${props => props.theme.colors.grayLighter};
  border: 0;
  caret-color: ${props => props.theme.colors.primary};
  color: ${props => props.theme.colors.light};
  flex: 100%;
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('18px')};
  min-width: 0;
  padding: ${rem('12px')} ${rem('20px')};
  &:focus {
    background-color: ${props => props.theme.colors.grayDarkest};
  }

  ${mediaqueries.greaterThan('mobile')`
    padding: ${rem('20px')} ${rem('30px')};
    font-size: ${rem('22px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    padding: ${rem('24px')} ${rem('30px')};
  `};
`;

const ButtonSearch = styled.button`
  background-color: ${props => props.theme.colors.grayDark};
  border: 0;
  color: ${props => props.theme.colors.light};
  display: flex;
  padding: ${rem('10px')} ${rem('15px')};

  ${mediaqueries.greaterThan('mobile')`
    padding: ${rem('20px')} ${rem('25px')};
  `};

  ${mediaqueries.greaterThan('desktop')`
    padding: ${rem('24px')} ${rem('30px')};
  `};
`;

export { WrapperSearch, InputSearch, ButtonSearch };
